import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';

import { ComponentBase, DbaDataTableColumn, DbaMAtTableDatatypesEnum, DialogData } from '@definitiv-packages/angular-dba-library';

import { AppService, DebitorModelView, DebitorViewService, ProjectLanguage, ProjektPermissionService } from '../../../../../roofsafetymanagement-library/src/public-api';

import { CreateDebitorComponent } from '../../dialogs/create-debitor/create-debitor.component';

@Component({
  selector: 'app-debitor-main-view',
  templateUrl: './debitor-main-view.component.html',
  styleUrls: ['./debitor-main-view.component.scss'],
  standalone: false
})
export class DebitorMainViewComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  public importing: boolean = false;
  public isAdmin: boolean = false;
  public isAppAdmin: boolean = false;
  public debitorList: DebitorModelView[] = [];
  public selectedDebitor: DebitorModelView | null = null;
  public enablecreatebutton: boolean = false;

  public columnsdefMain: DbaDataTableColumn<DebitorModelView, ProjectLanguage>[] = [
    { id: 'Nummer', label: 'Nummer' },
    { id: 'Name', label: 'Name' },
    { id: 'Strasse', label: 'Strasse' },
    { id: 'PLZ', label: 'PLZ', width: 100 },
    { id: 'Ort', label: 'Ort' },
    { id: 'LandName', label: 'Land' },
    { id: 'EMail', label: 'EMail' },
    { id: 'Telefon', label: 'Telefon' }
  ];

  constructor(
    public permissionService: ProjektPermissionService,
    private debitorViewService: DebitorViewService,
    private appService: AppService,
    private dialog: MatDialog
  ) { super(); }

  public async ngOnInit() {
    this.isAdmin = this.appService.isUserAdmin();
    this.isAppAdmin = this.appService.isAppAdmin();
    this.loading = true;

    await this.getDebitorList();

    this.loading = false;
  }

  public async getDebitorList(): Promise<void> {
    try {
      var result = await Promise.all([this.debitorViewService.getList()]);
      this.debitorList = result[0];
    } catch {
    }
  };

  //  public DeleteDataMain(selected: (DebitorModelView | null)[]): void {
  //    BuildDeleteDataPromise<Personal | null>(selected, (element) => { return this.debitorService.DeleteDebitor(element!) }).then(() => this.getPersonalList());
  //  };

  public async OpenDialog(data: DialogData<DebitorModelView>): Promise<void> {
    if (!this.permissionService.DebitorSchreiben) return;

    var debitor = await firstValueFrom(this.dialog.open(CreateDebitorComponent, { data: data }).afterClosed());

    if (!debitor)
      return

    var changeddebitor = await this.debitorViewService.get(debitor.DebitorID)

    this.selectedDebitor = null;

    if (data.mode == 'create' || data.mode == 'copy')
      this.debitorList.push(changeddebitor);
    else if (data.mode == 'edit') {
      var index = this.debitorList.findIndex(x => x.DebitorID == debitor.DebitorID);
      if (index != -1)
        this.debitorList[index] = changeddebitor;
    }
    this.selectedDebitor = changeddebitor;
  }

  // public openPersonalFile(): void {
  //   this.dialog.open(PersonalFileComponent, { data: this.selectedPersonal ,width:'95vw',maxWidth:'95vw'});
  // }
}
